import React, { useState, useEffect } from 'react';
import { Play, Heart } from 'lucide-react';
import SongMenu from '../SongMenu';

const TrendingSongs = ({ playSong, likedSongs, toggleLike, user }) => {
  const [trendingSongs, setTrendingSongs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/songs/trending`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
            }
          }
        );
        if (response.ok) {
          const data = await response.json();
          setTrendingSongs(data);
        }
      } catch (error) {
        console.error('Failed to load trending songs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrending();
  }, []);

  if (loading) {
    return (
      <div className="page-content">
        <div className="page-header">
          <h1>Trending Now</h1>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="page-header" style={{ marginBottom: '32px' }}>
        <div>
          <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '8px' }}>
            Trending Now
          </h1>
          <p style={{ color: '#999', fontSize: '16px' }}>
            What everyone's vibing to right now • {trendingSongs.length} songs
          </p>
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button 
            className="play-all-button"
            onClick={() => trendingSongs.length > 0 && playSong(trendingSongs[0], trendingSongs)}
            style={{
              background: '#9D4EDD',
              color: 'white',
              border: 'none',
              borderRadius: '24px',
              padding: '12px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            <Play size={20} fill="white" />
            Play All
          </button>
          <button 
            className="shuffle-button"
            onClick={() => {
              const shuffled = [...trendingSongs].sort(() => Math.random() - 0.5);
              if (shuffled.length > 0) playSong(shuffled[0], shuffled);
            }}
            style={{
              background: 'transparent',
              color: '#9D4EDD',
              border: '2px solid #9D4EDD',
              borderRadius: '24px',
              padding: '12px 24px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"/>
            </svg>
            Shuffle
          </button>
        </div>
      </div>

      {trendingSongs.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '64px 24px',
          color: '#999'
        }}>
          <p style={{ fontSize: '18px' }}>No trending songs available</p>
        </div>
      ) : (
        <div className="songs-grid">
          {trendingSongs.map(song => (
            <div key={song.id} className="song-card">
              <div className="song-card-image">
                <img src={song.albumArt || song.album_art_url} alt={song.title} />
                <SongMenu song={song} user={user} />
                <button 
                  className="play-button"
                  onClick={() => playSong(song, trendingSongs)}
                >
                  <Play size={20} fill="white" />
                </button>
              </div>
              <div className="song-card-content">
                <h3 className="song-title">{song.title}</h3>
                <p className="song-artist">{song.artist}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrendingSongs;
